import { Component, OnInit } from '@angular/core';
import { ContactService } from '../contact.service';

@Component({
  selector: 'app-recharge',
  templateUrl: './recharge.component.html',
  styleUrls: ['./recharge.component.scss']
})
export class RechargeComponent implements OnInit {

  constructor(private contactSevice:ContactService) { }

  ngOnInit() {
    // this.getLink()
  }

  getLink(){
    this.contactSevice.get('/pullData/getSetuLink?mobileNumber=9481773053').subscribe(res=>{
      console.log(res);
      
    })

  }
// https://socket.oneqlik.in/pullData/getSetuLink?mobileNumber=9481773053
}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/recharge/recharge.component.ts